module.exports = __webpack_public_path__ + "static/media/left.0365e0a0.svg";